"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 4.431 8.437 7.737a.7.7 0 0 1-.54.395l-3.474.46 2.502 2.717a.7.7 0 0 1 .173.602l-.682 3.668 3.269-1.648a.7.7 0 0 1 .63 0l3.27 1.648-.683-3.668a.7.7 0 0 1 .173-.602l2.503-2.717-3.474-.46a.7.7 0 0 1-.54-.395zm-1.244-.643c.497-1.052 1.991-1.052 2.489 0l1.42 3.006 3.138.416c1.109.146 1.586 1.482.832 2.3L14.342 12l.627 3.366c.208 1.118-.952 2-1.973 1.484L10 15.34l-2.996 1.51c-1.02.515-2.18-.366-1.973-1.484L5.658 12 3.366 9.51c-.755-.818-.277-2.154.831-2.3l3.137-.416z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StarOutlineIcon20.js.map